import React, { useState } from "react";

import customerImg from "../../assets/customer_support.png";
import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";

import { FaRobot, FaUserTie } from "react-icons/fa";

const styles = `
  /* ── HEADER ── */
  .cs-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .cs-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .cs-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47,183,164,0.7);
  }

  .cs-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0,0,0,0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 520px;
    max-width: 100%;
  }

  .cs-header-icon-box {
    width: 36px;
    height: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .cs-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .cs-triangle-left {
    position: absolute;
    left: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .cs-triangle-right {
    position: absolute;
    right: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .cs-header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .cs-header-title h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  /* ── MAIN ── */
  .cs-main {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 80px;
    gap: 60px;
  }

  .cs-image-wrap {
    flex: 1;
  }

  .cs-image-wrap img {
    width: 100%;
  }

  .cs-accordion {
    flex: 1;
    max-width: 600px;
  }

  .cs-accordion-item {
    margin-bottom: 18px;
  }

  .cs-accordion-header {
    background: linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f);
    color: #fff;
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-weight: 500;
    font-size: 15px;
  }

  .cs-accordion-body {
    padding: 20px;
    color: #555;
    line-height: 1.6;
  }

  /* ── TABLET (max-width: 1024px) ── */
  @media (max-width: 1024px) {
    .cs-header {
      height: auto;
      min-height: 90px;
    }

    .cs-header-badge {
      width: auto;
      padding: 10px 14px;
      font-size: 14px;
    }

    .cs-header-title h2 {
      font-size: 22px;
    }

    .cs-triangle-left,
    .cs-triangle-right {
      width: 50px;
    }

    .cs-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── SMALL TABLET / LANDSCAPE MOBILE (max-width: 768px) ── */
  @media (max-width: 768px) {
    .cs-header {
      flex-direction: column;
      height: auto;
    }

    .cs-header-left {
      flex: none;
      height: 80px;
      padding: 0 16px;
    }

    .cs-header-badge {
      width: 100%;
      font-size: 13px;
      padding: 10px 14px;
    }

    .cs-header-right {
      flex: none;
      height: 70px;
      border-top: 1px solid #e5e5e5;
    }

    .cs-triangle-left,
    .cs-triangle-right {
      width: 40px;
    }

    .cs-header-title h2 {
      font-size: 18px;
    }

    .cs-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .cs-image-wrap {
      width: 100%;
    }

    .cs-accordion {
      width: 100%;
      max-width: 100%;
      flex: none;
    }

    .cs-accordion-header {
      font-size: 14px;
      padding: 10px 16px;
    }
  }

  /* ── PORTRAIT MOBILE (max-width: 480px) ── */
  @media (max-width: 480px) {
    .cs-header-left {
      height: 70px;
      padding: 0 12px;
    }

    .cs-header-badge {
      font-size: 12px;
      padding: 8px 10px;
      gap: 8px;
    }

    .cs-header-icon-box {
      width: 28px;
      height: 28px;
    }

    .cs-header-right {
      height: 60px;
    }

    .cs-header-title h2 {
      font-size: 15px;
    }

    .cs-triangle-left,
    .cs-triangle-right {
      width: 28px;
    }

    .cs-main {
      padding: 20px 14px;
      gap: 24px;
    }

    .cs-accordion-header {
      font-size: 13px;
      padding: 9px 12px;
    }

    .cs-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }

    .cs-accordion-item {
      margin-bottom: 12px;
    }
  }
`;

function CustomerServicePage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Social Listening & Ticketing",
      content:
        "AI uses the data accessible in social networks to discover whom to sell and what to sell."
    },
    {
      title: "2.Intelligent Call Routing",
      content:
        "AI delivers the correct service with the right agent based on customer profile."
    },
    {
      title: "3.Call Classification",
      content:
        "AI uses NLP to recognize customer intent so agents can resolve faster."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* HEADER */}
      <div className="cs-header">

        {/* LEFT */}
        <div
          className="cs-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="cs-header-overlay" />

          <div className="cs-header-badge">
            <div className="cs-header-icon-box">
              <FaRobot style={{ color: "#fff" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span style={{ marginLeft: "auto", fontSize: "22px" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="cs-header-right">
          <div className="cs-triangle-left" />
          <div className="cs-triangle-right" />

          <div className="cs-header-title">
            <FaUserTie style={{ fontSize: "32px", color: "#2fb7a4", flexShrink: 0 }} />
            <h2>Customer Service</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="cs-main">

        {/* LEFT IMAGE */}
        <div className="cs-image-wrap">
          <img
            src={require("../../assets/customer_support.png")}
            alt="Customer service"
          />
        </div>

        {/* RIGHT ACCORDION */}
        <div className="cs-accordion">
          {data.map((item, i) => (
            <div key={i} className="cs-accordion-item">

              <div
                className="cs-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}

                <span
                  style={{
                    fontSize: "22px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="cs-accordion-body">
                  {item.content}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CustomerServicePage;
